import { elementExists } from "../utils";
import eventBus from "../services/event-bus";;
import QuantityComponent from "./quantity";

const CartDrawer = function (cartSelector, triggerSelector, options = { openOnAdd: false }) {
  const { openOnAdd } = options;
  const cartElement = document.querySelector(cartSelector);
  const triggerElement = document.querySelectorAll(triggerSelector);
  let removeButtons = cartElement.querySelectorAll('[data-cart-remove]');

  const init = () => {
    if (elementExists(triggerElement, true) && elementExists(cartElement)) {
      triggerElement.forEach(el => {
        el.addEventListener('click', function ($e) {
          $e.preventDefault();
          cartElement.classList.toggle('open');
        })
      });
    }

    if (elementExists(removeButtons, true)) {
      removeButtons.forEach(btn => {
        btn.addEventListener('click', removeItem);
      })
    }
    if (openOnAdd) {
      eventBus.on(eventBus.types.AddedToCart, (data) => {
        if (data.detail.success == true) {
          cartElement.classList.toggle('open');
        }
      });
    }

    eventBus.on(eventBus.types.CartUpdated, () => {
      updateCart();
    });
  }



  const removeItem = (e) => {
    e.preventDefault();
    const elm = e.target.closest('[data-cart-item]');
    const key = elm.getAttribute('data-cart-item-key');

    Shopify.cartService.removeItem(key).then(function (response) {
      if (response.success) {
        fadeOut(elm);
      }
    });
  }

  const fadeOut = (elm) => {
    const fadeEffect = setInterval(function () {
      if (!elm.style.opacity) {
        elm.style.opacity = 1;
      }
      if (elm.style.opacity > -0.3) {
        elm.style.opacity -= 0.1;
      } else {
        clearInterval(fadeEffect);
        elm.remove();
      }
    }, 30);
  }

  const updateCart = () => {
    cartElement.querySelector('[data-cart-line-items]').innerHTML = '';

    Shopify.cartService.cart.items.forEach((product, i) => {
      let template = document.querySelector('#cart-drawer-product');
      let renderableTemplate = template.content.cloneNode(true);
      let cartRow = renderableTemplate.querySelector('.cart__row');
      let cartImage = renderableTemplate.querySelector('.cart__image');
      let productTitle = renderableTemplate.querySelector('.cart__product-title');
      let quantityInput = renderableTemplate.querySelector('.product-form__qty-input');
      let removeText = renderableTemplate.querySelector('.text-link--accent');

      cartRow.setAttribute('data-cart-item-key', product['key']);
      cartRow.setAttribute('data-cart-item-url', product['url']);
      cartRow.setAttribute('data-cart-item-title', product['title']);
      cartRow.setAttribute('data-cart-item-index', i);
      cartRow.setAttribute('data-cart-item-quantity', product['quantity']);
      cartImage.setAttribute('src', product['image']);
      cartImage.setAttribute('alt', product['title']);
      productTitle.setAttribute('href', product['url']);
      productTitle.innerHTML = product['title'];
      quantityInput.setAttribute('id', `Quantity-${product['id']}`);
      quantityInput.setAttribute('value', product['quantity']);
      removeText.setAttribute('aria-label', `Remove ${product['title']}`);

      cartElement.querySelector('[data-cart-line-items]').appendChild(renderableTemplate);
    });

    // update event listeners
    removeButtons = cartElement.querySelectorAll('[data-cart-remove]');
    removeButtons.forEach(btn => {
      btn.addEventListener('click', removeItem);
    });

    let quantitiyButtons = cartElement.querySelectorAll('[sh-quantity-component]');

    quantitiyButtons.forEach(btn => {
      let quantityComponent = new QuantityComponent(btn);
    });
  }

  init();
};

export default CartDrawer;
